import { FC } from 'react';
import {
  Stack,
  Box,
  Heading,
  Flex,
  Text,
  Spacer,
  Center,
} from '@chakra-ui/react';
import { useEditDetailStore } from '../../../hooks';
import { CrawlerDetailInputModalView } from '../CrawlerDetailInputModalView';
import { CrawlerDetailItemModalView } from './CrawlerDetailItemModalView';
import { AddIconButton } from '../../../../../components/atoms/AddIconButton';

type Props = ReturnType<typeof useEditDetailStore>;

export const CrawlerDetailsModalView: FC<Props> = ({
  crawlerDetails,
  pastCrawlerDetails,
  onOpenModalEditDetail,
  onOpenModalAddDetail,
  onOpenModalDeleteDetail,
  formState,
  register,
  control,
}) => (
  <Box borderWidth="1px" borderColor="gray.300" rounded="md">
    <Heading as="h3" size="sm" p="32px 32px 16px">
      <Flex alignItems="center">
        <Text>バージョン履歴</Text>
        <Spacer />
        <AddIconButton label="バージョン追加" onClick={onOpenModalAddDetail} />
      </Flex>
    </Heading>
    <Stack spacing="0" direction="column">
      {crawlerDetails.length > 0 ? (
        <CrawlerDetailInputModalView
          formState={formState}
          register={register}
          control={control}
          onOpenModalEditDetail={onOpenModalEditDetail}
          onOpenModalDeleteDetail={onOpenModalDeleteDetail}
        />
      ) : (
        <Center my="80px">
          <Text color="gray.400">バージョンはありません</Text>
        </Center>
      )}
      {pastCrawlerDetails.map((detail) => (
        <CrawlerDetailItemModalView
          detail={detail}
          p="32px"
          borderTopWidth="1px"
          borderTopColor="gray.300"
          key={detail.version}
        />
      ))}
    </Stack>
  </Box>
);
